module.exports = __webpack_public_path__ + "img/cs-baseSucc-4.bdad55d3.jpg";